import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./styles.scss";
import { RegionCard } from "../../components/RegionCard/region-card";
import { Filter } from "../../components/Filter/filter";
import { guests, hosts } from "../../assets/data/people";
import { PersonCard } from "./PersonCard/person-card";

const regions = ["Asia", "Europe", "Africa", "Latin America", "North America"];
const filters = [
  { name: "iGEM Staff", color: "#A5B4FC" },
  { name: "Alumni", color: "#F8ED6E" },
  { name: "Volunteer Committees", color: "#ED5757" },
  { name: "Ambassador", color: "#F59B55" },
  { name: "iGEM Friends", color: "#F8ED6E" },
];

export const People = (): JSX.Element => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const allFilters = filters.map((filter) => ({
    name: filter.name,
    color: filter.color,
    isActive: false,
  }));
  const [peopleFiltered, setPeopleFiltered] = useState(guests);
  const [people, setPeople] = useState(peopleFiltered);
  const [filtersState, setFiltersState] = useState(allFilters);
  const [activeRegion, setActiveRegion] = useState<string>("");
  const getFilterState = (filterName: string) =>
    filtersState.find((filter) => filter.name === filterName)?.isActive;
  const toggleFilter = (filterName: string) => {
    const result = filtersState.map((filter) =>
      filter.name === filterName
        ? { ...filter, isActive: !filter.isActive }
        : filter
    );
    setFiltersState(result);
  };
  useEffect(() => {
    const activeFilters = filtersState
      .filter((filter) => filter.isActive)
      .map((filter) => filter.name);
    if (activeFilters.length === 0) {
      setPeopleFiltered(guests);
    } else {
      const filteredGuests = guests.filter((guest) =>
        activeFilters.every((r) => guest.filters.includes(r))
      );
      setPeopleFiltered(filteredGuests);
    }
  }, [filtersState]);

  const setRegion = (region: string) => {
    if (region === activeRegion) {
      setActiveRegion("");
    } else {
      setActiveRegion(region);
    }
  };
  useEffect(() => {
    if (activeRegion === "") {
      setPeople(peopleFiltered);
    } else {
      const filteredGuests = peopleFiltered.filter(
        (guest) => guest.region === activeRegion
      );
      setPeople(filteredGuests);
    }
  }, [activeRegion, peopleFiltered]);

  return (
    <div className="pp">
      <div className="pp__header">
        <h1>People</h1>
        <div className="pp__header-info">
          <div className="pp__header-info-wrapper">
            <div className="pp__header-info__regions">
              {regions.map((region) => (
                <RegionCard
                  region={region}
                  shouldSetTeamCount={false}
                  onClick={() => setRegion(region)}
                  isActive={region === activeRegion}
                />
              ))}
            </div>
            <div className="pp__header-info__filters">
              {allFilters.map((filter) => (
                <Filter
                  key={filter.name}
                  onClick={() => toggleFilter(filter.name)}
                  name={filter.name}
                  isActive={getFilterState(filter.name)}
                  color={filter.color}
                />
              ))}
            </div>
          </div>
          <p className="country-info">
            * The term “country” in normal commercial use may refer to a
            country, region, province, or other economic area.
          </p>
        </div>
      </div>
      <div className="pp__hosts">
        <h2>Hosts</h2>
        <div className="pp__hosts-info">
          {hosts.map((person) => (
            <PersonCard person={person} key={person.id} />
          ))}
        </div>
      </div>
      <div className="pp__guests">
        <h2>Guests</h2>
        <div className="pp__guests-info">
          {people.sort((a, b) => a.name.localeCompare(b.name)).map((person) => (
            <PersonCard person={person} key={person.id} />
          ))}
        </div>
      </div>
      {people.length === 0 && (
        <h3 className="no-results">
          There were no search results - please try selecting other filters!
        </h3>
      )}
    </div>
  );
};
